import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (activeTab: string, isViewingOwnProfile: boolean) => {
  useRegisterAgentContext({
    kind: 'entity',
    description: 'The profile currently being viewed or edited',
    data: {
      activeTab,
      isViewingOwnProfile,
    },
  });
};
